export type FULFILLMENT_CHANNEL = 'leboncoin' | 'ebay_packlink' | 'temu' | 'sendcloud' | 'direct-sale';

export type SALE_CHANNEL = 'leboncoin' | 'ebay' | 'temu' | 'direct-sale' | 'aliexpress';

export const SALES_CHANNELS: Record<SALE_CHANNEL, { name: string; deliveryCountries: string[]; listingCountries: string[] }> = {
  leboncoin: {
    name: 'Leboncoin',
    deliveryCountries: ['FR'],
    listingCountries: ['FR'],
  },
  ebay: {
    name: 'Ebay',
    deliveryCountries: ['FR', 'DE', 'IT', 'ES', 'BE', 'NL', 'PT', 'IE'],
    listingCountries: ['FR'],
  },
  temu: {
    name: 'Temu',
    deliveryCountries: ['FR', 'DE', 'IT', 'ES', 'BE', 'NL', 'PT', 'IE', 'AT'],
    listingCountries: ['FR', 'DE', 'IT', 'ES', 'BE', 'NL', 'PT', 'IE', 'AT'],
  },
  aliexpress: {
    name: 'AliExpress',
    deliveryCountries: ['FR', 'DE', 'IT', 'ES', 'BE', 'NL', 'PT', 'IE', 'AT'],
    listingCountries: ['FR', 'DE', 'IT', 'ES', 'BE', 'NL', 'PT', 'IE', 'AT'],
  },
  'direct-sale': {
    name: 'Direct Sale',
    deliveryCountries: ['FR'],
    listingCountries: ['FR'],
  },
} as const;